import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      ADD: "Løs inn",
      EXPIRES: "Utløper: ",
      PLACEHOLDER: "Skriv inn rabattkode",
      SUCCESS: "Rabattkode lagt til!",
      REBATE: "rabatt",
      USES_LEFT: "Resterende leveranser med rabatt: ",
      INVALID_CODE: "Ugyldig kode",
      CODE_ACTIVE: "Koden er aktiv",
    },

    se: {
      ADD: "Lös in",
      EXPIRES: "Löper ut: ",
      PLACEHOLDER: "Ange rabattkod",
      SUCCESS: "Rabattkod tillagd!",
      REBATE: "rabatt",
      USES_LEFT: "Återstående leveranser med rabatt: ",
      INVALID_CODE: "Ogiltig kod",
      CODE_ACTIVE: "Koden är aktiv",
    },

    dk: {
      ADD: "Indløs",
      EXPIRES: "Udløber: ",
      PLACEHOLDER: "Indtast rabatkode",
      SUCCESS: "Rabatkode tilføjet!",
      REBATE: "rabat",
      USES_LEFT: "Resterende leverancer med rabat: ",
      INVALID_CODE: "Ugyldig kode",
      CODE_ACTIVE: "Koden er aktiv",
    },
  } as const
)[language];
